import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SEO from "./SEO";
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <SEO
        title="Solar Panels in Sukkur | Best Solar Company in Sukkur - Solidera Energy"
        description="Solidera Energy offers affordable solar panel installation in Sukkur, Rohri & Khairpur. Get complete solar systems, net metering, inverter & battery solutions. Call 0333-7111075 for free consultation."
        url="https://solidera-energy.com/"
      />
    </>
  );
}
